import { Avatar, AvatarFallback, AvatarImage } from '../ui';

type TProps = {
  signature?: string;
  urlImage?: string;
  username: string;
  email?: string;
};

const BadgeUserInfo = ({ email, username, urlImage, signature }: TProps) => (
  <div className='flex items-center space-x-4'>
    <Avatar>
      {
        urlImage &&
        <AvatarImage
          src={urlImage}
          alt={username ?? ''} />
      }
      <AvatarFallback className='bg-primary text-muted'>
        {(signature ?? `${username.split(' ')[0]?.[0]}${username.split(' ')[1]?.[0] ?? ''}`).toUpperCase()}
      </AvatarFallback>
    </Avatar>
    <div>
      <p className='text-sm font-medium leading-none'>
        {username}
      </p>
      {
        email &&
        <p className='text-sm text-muted-foreground'>
          {email}
        </p>
      }
    </div>
  </div>
);

export default BadgeUserInfo;
